"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedAttributionIcon = void 0;
var Attribution_1 = require("./Attribution");
Object.defineProperty(exports, "FixedAttributionIcon", { enumerable: true, get: function () { return __importDefault(Attribution_1).default; } });
